import { c as _c } from "react/compiler-runtime";
import { type Ref } from 'react';
import { type ListBoxItemProps, type SelectProps, type ValidationResult } from 'react-aria-components';
import { Button, ListBox, ListBoxItem, Popover, Select as AriaSelect, SelectValue } from 'react-aria-components';
import { FaAngleDown } from 'react-icons/fa6';
import styles from './select.module.scss';
interface MySelectProps<T extends object> extends Omit<SelectProps<T>, 'children'> {
  label?: string;
  description?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
  items?: Iterable<T>;
  children: React.ReactNode | ((item: T) => React.ReactNode);
  ref?: Ref<HTMLButtonElement>;
}
function Select(t0) {
  const $ = _c(16);
  let children;
  let items;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      children,
      items,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = items;
    $[3] = props;
    $[4] = ref;
  } else {
    children = $[1];
    items = $[2];
    props = $[3];
    ref = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SelectValue />;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden="true" className={styles.select_icon}><FaAngleDown /></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== ref) {
    t3 = <Button ref={ref} className={styles.select_selectButton}>{t1}{t2}</Button>;
    $[7] = ref;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== items) {
    t4 = <Popover maxHeight={320} className={styles.select_popover}><ListBox className={styles.select_list} items={items}>{children}</ListBox></Popover>;
    $[9] = children;
    $[10] = items;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props || $[13] !== t3 || $[14] !== t4) {
    t5 = <AriaSelect {...props} className={styles.select}>{t3}{t4}</AriaSelect>;
    $[12] = props;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function SelectItem(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ListBoxItem {...props} className={styles.select_option} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
Select.Option = SelectItem;
export default Select;